const extractOriginalTextFromMarkup = markedText => {
  if (!markedText) {
    return "";
  }

  // Remove additions (text between ≤...≤)
  let originalText = markedText.replace(/≤([^≤≥]*)≤/g, "");

  // Restore deletions (text between ≥...≥)
  originalText = originalText.replace(/≥([^≤≥]*)≥/g, "$1");

  return originalText;
};

export default extractOriginalTextFromMarkup;
